// Aggregated ru/shared catalog. Apps merge this into their namespaces map
// when calling createI18n().
import { auth } from './auth.js';
import { common } from './common.js';
import { dates } from './dates.js';
import { errors } from './errors.js';
import { roles } from './roles.js';
import { validation } from './validation.js';
import type { Namespace, NamespaceMap } from '../../../types.js';

/** Single aggregated `'shared'` namespace ready for {@link createI18n}. */
export const sharedNamespace: Namespace = {
  ...common,
  ...auth,
  ...errors,
  ...validation,
  ...roles,
  ...dates,
};

/** Pre-wired namespace map so apps can do `createI18n({ namespaces: ruShared })`. */
export const ruShared: NamespaceMap = {
  shared: sharedNamespace,
};

export { common, auth, errors, validation, roles, dates };
